var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCannotExistRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_178108",
    "data-name": "Group 178108",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1752",
    "data-name": "Ellipse 1752",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prohibited-svgrepo-com",
    d: "M11,5a6,6,0,1,1-6,6A6,6,0,0,1,11,5Zm3.953,2.605L7.605,14.953a5.211,5.211,0,0,0,7.348-7.348ZM11,5.789a5.211,5.211,0,0,0-3.953,8.605l7.348-7.348A5.19,5.19,0,0,0,11,5.789Z",
    transform: "translate(-5 -5)",
    fill: "#e32b35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannotExistRule);
export default __webpack_public_path__ + "static/media/CannotExistRule.5ce7e03184226d6265e720ec153351c2.svg";
export { ForwardRef as ReactComponent };